<script>
import { useAlert } from 'dashboard/composables';
import Spinner from 'shared/components/Spinner.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import AttachmentsPreview from 'dashboard/components/widgets/AttachmentsPreview.vue';

export default {
  components: {
    Spinner,
    NextButton,
    AttachmentsPreview,
  },
  props: {
    initialFiles: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      files: [],
      uploading: false,
    };
  },
  computed: {
    attachmentsForPreview() {
      return this.files.map(f => ({
        id: f.blob_id,
        resource: {
          filename: f.filename,
          content_type: f.content_type || 'application/octet-stream',
          byte_size: f.size || 0,
          size: f.size || 0,
        },
        thumb: f.thumb || null,
      }));
    },
  },
  mounted() {
    if (this.initialFiles.length) {
      this.files = this.initialFiles.map(f => {
        const contentType = f.file_type || 'application/octet-stream';
        return {
          blob_id: f.blob_id,
          filename: f.filename,
          content_type: contentType,
          size: f.byte_size || 0,
          thumb: contentType.includes('image') ? f.file_url : null,
        };
      });
    }
  },
  methods: {
    async onChangeFile(event) {
      const newFiles = Array.from(event.target.files);
      if (!newFiles.length) return;

      this.uploading = true;
      try {
        const uploads = newFiles.map(file =>
          this.$store
            .dispatch('automations/uploadAttachment', file)
            .then(blobId => {
              const fileEntry = {
                blob_id: blobId,
                filename: file.name,
                content_type: file.type,
                size: file.size,
                thumb: file.type.includes('image')
                  ? URL.createObjectURL(file)
                  : null,
              };
              this.files.push(fileEntry);
            })
        );
        await Promise.all(uploads);
        this.emitBlobIds();
      } catch (error) {
        useAlert(this.$t('AUTOMATION.ATTACHMENT.UPLOAD_ERROR'));
      } finally {
        this.uploading = false;
        event.target.value = '';
      }
    },
    onRemoveAttachment(updatedAttachments) {
      this.files = this.files.filter(f =>
        updatedAttachments.some(a => a.id === f.blob_id)
      );
      this.emitBlobIds();
    },
    emitBlobIds() {
      this.$emit(
        'update:modelValue',
        this.files.map(f => f.blob_id)
      );
    },
  },
};
</script>

<template>
  <div>
    <AttachmentsPreview
      v-if="files.length"
      class="mt-2 overflow-auto"
      :attachments="attachmentsForPreview"
      @remove-attachment="onRemoveAttachment"
    />
    <div class="flex items-center mt-1 py-1">
      <input
        ref="fileInput"
        type="file"
        multiple
        class="hidden"
        @change="onChangeFile"
      />
      <NextButton
        v-if="!uploading"
        type="button"
        icon="i-ph-paperclip"
        slate
        faded
        sm
        @click="$refs.fileInput.click()"
      />
      <Spinner v-else />
    </div>
  </div>
</template>
